document.addEventListener('DOMContentLoaded', function () {


    const formatCurrencyText = (raw) => {
        const text = raw.trim();

        // Matches: "New Zealand (NZD $)" -> captures "NZD $"
        const parenMatch = text.match(/\(([^)]+)\)\s*$/);
        if (parenMatch?.[1]) return parenMatch[1].trim();

        // Fallback: if it already contains "NZD $" etc, try to pull "AAA $" shape
        const codeSymbolMatch = text.match(/\b([A-Z]{3})\s*([$€£¥]|฿)\b/);
        if (codeSymbolMatch) return `${codeSymbolMatch[1]} ${codeSymbolMatch[2]}`;

        return text;
    };

    const replacePlaceholders = (template, config) => {
        return template
            .replace(/{{LINK}}/g, config.link)
            .replace(/{{LABEL}}/g, config.label)
            .replace(/{{SUB_LABEL}}/g, config.sub_label)
            .replace(/{{IMAGE_URL}}/g, config.image);
    };

    const announcement__localization = document.querySelector('#nav-localization');
    if (announcement__localization) {

        // currency desktop
        const getTextStartEl = () => announcement__localization.querySelector('.text-start');

        const updateTextStart = () => {
            const el = getTextStartEl();
            if (!el) return;

            const next = formatCurrencyText(el.textContent || '');
            if (next && el.textContent?.trim() !== next) {
                el.textContent = next;
            }
        };

        // Run once immediately
        updateTextStart();

        // Observe future changes
        const observer = new MutationObserver(() => {
            updateTextStart();
        });

        observer.observe(announcement__localization, {
            subtree: true,
            childList: true,
            characterData: true
        });
    }


    // login for mobile
    const loginBtn = document.querySelector('.header__icon.sv-log_in');
    if (loginBtn) {
        const loginLInk = loginBtn.getAttribute('href');

        const seconday_menu = document.querySelector('.secondary-nav-container ul');
        const new_li = document.createElement('li');
        new_li.classList.add('sv-mobile_login', 'inline-flex', 'items-left');
        new_li.innerHTML = `<a class="main-nav__item main-nav__item--primary" href="${loginLInk}">Log in</a>`;

        if (seconday_menu) {
            seconday_menu.prepend(new_li);
        }
    }

    // make kit lowercase
    const kitLink = document.querySelector('.secondary-nav a[href="/pages/quiz"]');
    if (kitLink) {
        kitLink.textContent = kitLink.textContent.replace('KIT', 'Kit');
    }

    // rename the back button
    document.querySelectorAll('.main-menu__content details .child-nav .js-back').forEach((el) => {
        el.closest('li')?.classList.add('sv-back-button');
    });

    // change the text of the menu
    document.querySelectorAll('.main-menu__content .main-nav__child li a').forEach((el) => {
        const a = el;

        const raw = (a.textContent || '').trim();
        if (!raw) return;

        const normalized = raw.replace(/\s+/g, ' ');

        const isIFirstAid = normalized.toLowerCase() === 'ifirstaid app';
        const isEBook = normalized.toLowerCase() === 'first aid ebook';

        if (isIFirstAid) {
            if (a.textContent !== 'iFirstAid App') a.innerHTML = '<i>i</i>FirstAid App';
            return;
        }

        if (isEBook) {
            if (a.textContent !== 'First Aid eBook') a.innerHTML = 'First Aid &nbsp;<i>e</i>Book';
            return;
        }
    });

    // add classes to mega menu items to display the proper icon
    document.querySelectorAll('.main-nav__child.mega-nav li').forEach((el) => {
        var text = el.textContent.trim().toLowerCase();
        if (text === 'shop all first aid kits') {
            if (el.querySelector('a')) {
                el.querySelector('a').innerHTML = 'Shop All KITs';
                el.classList.add('sv-shop-all');
            }
        } else if (text === 'shop all') {
            el.classList.add('sv-shop-all');
        }

        text = text.replace(/\s+/g, '-').replace(/\//g, '').replace(/\&+/g, '').replace(')', '').replace('(', '');
        el.classList.add('sv-menu-item-' + text);
    });

    // click on the third menu
    if (window.innerWidth > 769 && window.innerWidth < 1025) {
        const menu_icon = document.querySelector('.main-menu summary');
        if (menu_icon) {
            menu_icon.click();

            document.querySelectorAll('.sv-third-level .is-open').forEach(function (el) {
                el.classList.remove('is-open');
            });
            document.querySelectorAll('.sv-third-level [open]').forEach(function (el) {
                el.removeAttribute('open');
                el.classList.remove('sv-is-open-third');
            });
            document.querySelectorAll('.sv-third-level').forEach(function (el) {
                el.removeAttribute('open');
                el.classList.remove('sv-is-open-third');
            });

            document.querySelectorAll('.main-nav > li > details > summary').forEach(function (el) {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    el.closest('details')?.classList.add('sv-is-open');
                });
            });

            document.querySelectorAll('.main-nav__child .sv-back-button button').forEach(function (el) {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    el.closest('details')?.classList.remove('sv-is-open');
                });
            });

            document.querySelectorAll('.sv-third-level > summary').forEach(function (el) {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    console.log('click', el);
                    el.closest('.sv-third-level')?.setAttribute('open', '');
                    el.closest('.sv-third-level')?.classList.add('sv-is-open-third');
                });
            });

            document.querySelectorAll('.sv-third-level .sv-back-button').forEach(function (el) {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    el.closest('.sv-third-level')?.removeAttribute('open');
                    el.closest('.sv-third-level')?.classList.remove('sv-is-open-third');
                });
            });
        }
    }

    // add the image
    const accessoriesImage = 'https://cdn.shopify.com/s/files/1/0269/7497/8132/files/menu_images_1.png?v=1768350749';
    const adventureImage = 'https://cdn.shopify.com/s/files/1/0269/7497/8132/files/menu_images.png?v=1768350749';
    const homeImage = 'https://cdn.shopify.com/s/files/1/0269/7497/8132/files/menu_images_1.png?v=1768350749';
    const vehicleImage = 'https://cdn.shopify.com/s/files/1/0269/7497/8132/files/menu_images_2.png?v=1768350749';
    const workImage = 'https://cdn.shopify.com/s/files/1/0269/7497/8132/files/menu_images_3.png?v=1768350749';
    const ImageHtml = `<a href="{{LINK}}">
        <img src="{{IMAGE_URL}}" alt="{{LABEL}}">
        <span class="sv-menu-image-sub-label">{{SUB_LABEL}}</span>
        <span class="sv-menu-image-label">{{LABEL}}
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none">
                <path d="M0.75 0.75L4.5 4.5L0.75 8.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </span>
    </a>`;
    
    document.querySelectorAll('.main-menu__content summary').forEach((el) => {
        const text = el.textContent.trim().toLowerCase();
        const link = el.querySelector('a')?.getAttribute('href') || '';
        if (text.indexOf('accessories') !== -1) {
            const image = document.createElement('div');
            image.innerHTML = replacePlaceholders(ImageHtml, {label: 'Accessories', sub_label: 'Shop all', image: accessoriesImage, link: link});
            image.classList.add('sv-menu-image-container');

            el.closest('details')?.querySelector('ul')?.insertAdjacentElement('afterend', image);
        } else if (text.indexOf('adventure') !== -1) {
            const image = document.createElement('div');
            image.innerHTML = replacePlaceholders(ImageHtml, {label: 'Adventure kits', sub_label: 'Shop all', image: adventureImage, link: link});
            image.classList.add('sv-menu-image-container');

            el.closest('details')?.querySelector('ul')?.insertAdjacentElement('afterend', image);
        } else if (text.indexOf('home') !== -1) {
            const image = document.createElement('div');
            image.innerHTML = replacePlaceholders(ImageHtml, {label: 'Home kits', sub_label: 'Shop all', image: homeImage, link: link});
            image.classList.add('sv-menu-image-container');

            el.closest('details')?.querySelector('ul')?.insertAdjacentElement('afterend', image);
        } else if (text.indexOf('vehicle') !== -1) {
            const image = document.createElement('div');
            image.innerHTML = replacePlaceholders(ImageHtml, {label: 'Vehicle kits', sub_label: 'Shop all', image: vehicleImage, link: link});
            image.classList.add('sv-menu-image-container');

            el.closest('details')?.querySelector('ul')?.insertAdjacentElement('afterend', image);
        } else if (text.indexOf('work') !== -1) {
            const image = document.createElement('div');
            image.innerHTML = replacePlaceholders(ImageHtml, {label: 'Work kits', sub_label: 'Shop all', image: workImage, link: link});
            image.classList.add('sv-menu-image-container');

            el.closest('details')?.querySelector('ul')?.insertAdjacentElement('afterend', image);
        }
    });

    //overlay for mobile
    const overlay = document.createElement('div');
    overlay.classList.add('sv-overlay');
    overlay.addEventListener('click', function (el) {
        const toggle_menu = document.querySelector('.main-menu__toggle');
        toggle_menu?.click();
    });
    document.querySelector('.main-menu summary')?.append(overlay);

});